import React from "react";
import "./style.scss"
import Fade from "react-reveal/Fade";

interface CardProps {
    className?: string;
    children?: React.ReactNode;
}

export class Card extends React.Component<CardProps> {

    render(): React.ReactElement {
        const cls = ['card', this.props.className].filter(Boolean).join(' ');
        return (
            <div className={cls}>
                <Fade bottom>
                    {this.props.children}
                </Fade>
            </div>);
    }
}